import React, { useEffect, useState } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import "ckeditor5/ckeditor5.css";
import {
  ListProperties,
  Alignment,
  List,
  Image,
  AutoImage,
  ImageInsert,
  ImageResize, // Add this
  ImageToolbar, // Add this
  ImageStyle, // Add this
  ImageCaption,
  SimpleUploadAdapter,
  Base64UploadAdapter,
} from "ckeditor5";

import {
  ClassicEditor,
  Bold,
  Essentials,
  Italic,
  Mention,
  Paragraph,
  Undo,
} from "ckeditor5";
import { imageUpload } from "../../../features/slices/liveStream";
import { toastService } from "../../../utils/toastify";
import { useDispatch } from "react-redux";
import LoaderForImage from "../../LoaderForImage";
import { useLocation, useNavigate } from "react-router-dom";
import {
  addEpiosde,
  addPodcast,
  getEpiosde,
} from "../../../features/slices/poadcast";
import QuillEditor from "../../QuillEditor";
import VideoPlayer from "../../VideoPlayer";
const initialState = {
  podcastId: "",
  episodName: "",
  videosLink: "",
  audioLink: "",
  hostName: "",
  guestName: "",
  duration: "",
  episodeDate: "",
  description: "",
  image: "",
};
const AddEpisode = () => {
  const [iState, setUpdateState] = useState(initialState);
  const [errors, setErrors] = useState({});
  const [imageLoader, setImageLoader] = useState({
    image: false,
    videosLink: false,
    audioLink: false,
  });
  const {
    episodName,
    audioLink,
    description,
    duration,
    episodeDate,
    guestName,
    hostName,
    videosLink,
    image,
    podcastId,
  } = iState;
  const dispatch = useDispatch();
  const { state } = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (state) {
      setUpdateState((prev) => ({
        ...prev,
        podcastId: state?.podcastId,
      }));
    }
  }, []);

  const validateForm = () => {
    let formErrors = {};
    let isValid = true;

    if (!episodName?.trim()) {
      formErrors.episodName = "Episode name is required.";
      isValid = false;
    }
    if (!guestName?.trim()) {
      formErrors.guestName = "Guest name is required.";
      isValid = false;
    }
    if (!hostName?.trim()) {
      formErrors.hostName = "Host name is required.";
      isValid = false;
    }
    if (!episodeDate?.trim()) {
      formErrors.episodeDate = "Episode Date is required.";
      isValid = false;
    }
    if (!description?.trim()) {
      formErrors.description = "Description is required.";
      isValid = false;
    }
    if (!image?.trim()) {
      formErrors.image = "Thumbnail is required.";
      isValid = false;
    }

    // Conditional logic for audioLink and videosLink
    if (!audioLink?.trim() && !videosLink?.trim()) {
      formErrors.audioLink = "Either Audio or Video is required.";
      formErrors.videosLink = "Either Audio or Video is required.";
      isValid = false;
    }

    setErrors(formErrors);
    return isValid;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setErrors((prev) => ({ ...prev, [name]: "" }));
    setUpdateState({ ...iState, [name]: value });
  };
  const handleQuillChange = (name, value) => {
    setErrors((prev) => ({ ...prev, [name]: "" })); // Reset error for the specific field
    setUpdateState((prev) => ({ ...prev, [name]: value })); // Dynamically update the corresponding state field
  };
  const handleChangeEditor = (name, value) => {
    setErrors((prev) => ({ ...prev, [name]: "" }));
    setUpdateState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleImage = (e) => {
    setErrors((prev) => ({ ...prev, [e?.target?.name]: "" }));
    const file = e.target.files[0];
    setImageLoader((prev) => ({
      ...prev,
      [e.target.name]: true,
    }));
    if (file) {
      const formData = new FormData();
      formData.append("fileName", file);
      dispatch(imageUpload(formData)).then((res) => {
        if (res?.payload?.code === 200) {
          if (file.type.startsWith("video/")) {
            const video = document.createElement("video");
            video.preload = "metadata";
            video.src = URL.createObjectURL(file);
            video.onloadedmetadata = function () {
              URL.revokeObjectURL(video.src);
              const durationInSeconds = video?.duration;
              setUpdateState((prev) => ({
                ...prev,
                duration: durationInSeconds,
                [e.target.name]: res?.payload?.url,
              }));
            };
          } else {
            setUpdateState((prev) => ({
              ...prev,
              [e.target.name]: res?.payload?.url,
            }));
          }
          console.log([e.target.name], res?.payload?.url);

          setImageLoader((prev) => ({
            ...prev,
            [e.target.name]: false,
          }));
          toastService.success(`${e.target.name} updated successfully`);
        } else {
          toastService.error(`${e.target.name} failed to upload`);
          console.log({ res });
          setImageLoader((prev) => ({
            ...prev,
            [e.target.name]: false,
          }));
        }
      });
    } else {
      toastService.error(`${e.target.name} failed to upload`);
    }
  };
  const handleSubmit = (e) => {
    if (validateForm()) {
      dispatch(addEpiosde(iState)).then((res) => {
        if (res?.payload?.code == 200) {
          toastService.success("Episode added successfully");
          navigate(state?.redirect, { state: { podcastId, add: false } });
          setUpdateState(initialState);
        } else {
          toastService.error("Failed to add episode");
        }
      });
    }
  };
  console.log({ errors });
  const today = new Date().toISOString().split("T")[0];
  const handleChangeEmbeddedVideo = (e) => {
    setErrors((prev) => ({
      ...prev,
      videosLink: "",
    }));
    setUpdateState((prev) => ({
      ...prev,
      videosLink: e?.target?.value,
    }));
  };
  return (
    <div className="WrapperArea">
      <div className="WrapperBox">
        <div className="Small-Wrapper">
          <div className="TitleBox Border">
            <h4 className="Title">Add Episode</h4>
          </div>
          <div className="CommonForm">
            {/* <div className="form-group">
              <label>Episode No.</label>
              <input
                type="text"
                className="form-control"
                placeholder="Auto-fill"
                name="episodName"
                value={episodName}
                onChange={handleChange}
              />
            </div> */}
            <div className="form-group">
              <label>Episode Name</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Episode Name"
                name="episodName"
                value={episodName}
                onChange={handleChange}
              />
              {errors.episodName && (
                <p className="d-flex justify-content-start text-danger mt-2 ">
                  {errors.episodName}
                </p>
              )}
            </div>
            <div className="form-group">
              <label>Host Name</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Host Name"
                name="hostName"
                value={hostName}
                onChange={handleChange}
              />
              {errors.hostName && (
                <p className="d-flex justify-content-start text-danger mt-2 ">
                  {errors.hostName}
                </p>
              )}
            </div>
            <div className="form-group">
              <label>Guest Name</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Host Name"
                name="guestName"
                value={guestName}
                onChange={handleChange}
              />
              {errors.guestName && (
                <p className="d-flex justify-content-start text-danger mt-2 ">
                  {errors.guestName}
                </p>
              )}
            </div>
            <div className="form-group">
              <label>Episode Date</label>
              <input
                type="date"
                className="form-control"
                placeholder="Enter Host Name"
                name="episodeDate"
                value={episodeDate}
                onChange={handleChange}
                min={today}
              />
              {errors.episodeDate && (
                <p className="d-flex justify-content-start text-danger mt-2 ">
                  {errors.episodeDate}
                </p>
              )}
            </div>
            <div className="form-group">
              <label>Podcast Description</label>
              {/* <CKEditor
                editor={ClassicEditor}
                config={{
                  toolbar: [
                    "undo",
                    "redo",
                    "|",
                    "bold",
                    "italic",
                    "|",
                    "paragraph",
                    "heading1",
                    "heading2",
                    "|",
                    "bulletedList",
                    // "numberedList",
                    "alignment",
                    "toggleImageCaption",
                    "imageTextAlternative",
                    "ckboxImageEdit",
                    "insertImage",
                    "imageResize",
                  ],
                  list: {
                    properties: {
                      styles: true,
                      startIndex: true,
                      reversed: true,
                    },
                  },
                  plugins: [
                    List,
                    ListProperties,
                    Bold,
                    Essentials,
                    Italic,
                    Mention,
                    Paragraph,
                    Undo,
                    Alignment,
                    Image,
                    AutoImage,
                    ImageInsert,
                    ImageResize, // Add this
                    ImageToolbar, // Add this
                    ImageStyle, // Add this
                    ImageCaption,
                    SimpleUploadAdapter,
                    Base64UploadAdapter, // Add this
                  ],
                  image: {
                    toolbar: [
                      "imageTextAlternative",
                      "toggleImageCaption",
                      "imageStyle:inline",
                      "imageStyle:block",
                      "imageStyle:side",
                    ],
                  },
                  simpleUpload: {
                    uploadUrl: "your-server-url-to-handle-image-upload", // Add your upload API here
                  },
                  mention: {
                    // Mention configuration
                  },
                }}
                name="description"
                data={description}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  // console.log({ event, editor, data })
                  handleChangeEditor("description", data);
                }}
              />
              {errors.description && (
                <p className="d-flex justify-content-start text-danger mt-2 ">
                  {errors.description}
                </p>
              )} */}
              <QuillEditor
                name="description"
                value={description}
                onChange={handleQuillChange}
                error={errors.description}
                // Optional custom height
              />
            </div>
            <div className="form-group">
              <label>Embedded Video</label>
              <input
                type="text"
                className="form-control"
                placeholder="Embedded Video Url"
                onChange={handleChangeEmbeddedVideo}
                name="videosLink"
                value={videosLink}
              />
              {/* {errors.courseMedia.video && (
                <p className="d-flex justify-content-start text-danger mt-2 ">
                  {errors.courseMedia.video}
                </p>
              )} */}
            </div>
          </div>
          <div className="CommonForm">
            <div className="TitleBox Border">
              <h4
                className="Title"
                style={{
                  background: "none",
                }}
              >
                Upload Thumnail
              </h4>
            </div>
            {imageLoader.image ? (
              <LoaderForImage />
            ) : (
              <div className="UploadBox Image" style={{ position: "relative" }}>
                <span
                  style={{
                    zIndex: "99",
                    position: "absolute",
                    top: "0",
                    left: "0",
                    display: "block",
                    width: "100%",
                    height: "100%",
                  }}
                >
                  {!image ? (
                    <img src={require("../../../assets/images/upload.png")} />
                  ) : (
                    <>
                      <img
                        src={image}
                        alt=""
                        style={{
                          position: "absolute",
                          top: "0",
                          left: "0",
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          borderRadius: "inherit",
                        }}
                      />
                      <i
                        className="fas fa-edit"
                        style={{
                          position: "absolute",
                          top: "5px",
                          right: "5px",
                          color: "#fff",
                          background: "rgba(0, 0, 0, 0.6)",
                          borderRadius: "50%",
                          padding: "5px",
                          zIndex: 2,
                          cursor: "pointer",
                        }}
                      ></i>
                    </>
                  )}
                </span>
                <input
                  type="file"
                  accept=".png,.jpg,.jpeg"
                  name="image"
                  onChange={handleImage}
                />
                {!image && (
                  <p>
                    <label>Click to upload image</label> or <br /> drag &amp; drop
                  </p>
                )}
              </div>
            )}
            {errors.image && (
              <p className="d-flex justify-content-start text-danger  ">
                {errors.image}
              </p>
            )}
            {/* <div className="UploadBox">
              <span>
                <img src="images/upload-video.png" />
              </span>
              <p>
                <label>Click to upload</label> or <br /> drag &amp; drop
              </p>
            </div> */}
          </div>
          <div className="TitleBox Border">
            <h4 className="Title">Upload Audio &amp; Video</h4>
          </div>
          <div className="CommonForm" style={{ display: "flex" }}>
            {imageLoader.videosLink ? (
              <LoaderForImage />
            ) : (
              <div>
                <div
                  className="UploadBox Image"
                  style={{
                    position: "relative",
                    zIndex: 0,
                    border: "aliceblue",
                    backgroundColor: "none",
                  }}
                >
                  <span>
                    {videosLink ? (
                      <>
                        {/* <video
                          src={videosLink}
                          controls
                          style={{
                            position: "absolute",
                            top: "0",
                            left: "0",
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                            zIndex: 1, // Make sure the video is above the input
                          }}
                        /> */}
                        <VideoPlayer
                          url={videosLink}
                          divHeight="110px"
                          divStyle={{
                            height: "100%",
                            position: "absolute",
                            top: "0",
                            left: "0",
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                            zIndex: 1,
                          }}
                        />
                        <i
                          className="fas fa-edit"
                          style={{
                            position: "absolute",
                            top: "5px",
                            right: "5px",
                            color: "#fff",
                            background: "rgba(0, 0, 0, 0.6)",
                            borderRadius: "50%",
                            padding: "5px",
                            zIndex: 2, // Place icon above the video
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            document.querySelector(`#file-input`).click()
                          }
                        />
                      </>
                    ) : (
                      <img src={require("../../../assets/images/upload.png")} />
                    )}
                  </span>
                  <input
                    id={`file-input`} // Unique ID for each input
                    type="file"
                    name="videosLink"
                    accept=".mp4" // Accept only video files
                    style={{
                      position: "absolute",
                      top: "0",
                      left: "0",
                      width: "100%",
                      height: "100%",
                      opacity: 0, // Hide input when a video is present
                      zIndex: videosLink ? 0 : 2,
                      cursor: "pointer",
                    }}
                    onChange={handleImage}
                  />
                  {!videosLink && (
                    <p>
                      <label>Click to upload video</label> or <br /> drag &amp;
                      drop
                    </p>
                  )}
                </div>

                {errors.videosLink && (
                  <p className="d-flex justify-content-start text-danger ml-2 ">
                    {errors.videosLink}
                  </p>
                )}
              </div>
            )}
            {imageLoader.audioLink ? (
              <LoaderForImage />
            ) : (
              <div>
                <div
                  className={
                    audioLink ? "UploadBox ImagesforAudio" : "UploadBox Image"
                  }
                  style={{
                    position: "relative",
                    zIndex: 0,
                    width: "250px",
                    // border: audioLink ? "none" : "inherit",
                    // background: audioLink ? "none" : "inherit",
                  }}
                >
                  <span>
                    {audioLink ? (
                      <>
                        <audio
                          src={audioLink}
                          controls
                          style={{
                            position: "absolute",
                            top: "-23px",
                            left: "26px",
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                            mixBlendMode: "darken",
                            zIndex: 1, // Make sure the video is above the input
                          }}
                        />
                        <i
                          className="fas fa-edit"
                          style={{
                            position: "absolute",
                            top: "30px",
                            right: "-30px",
                            color: "#fff",
                            background: "rgba(0, 0, 0, 0.6)",
                            borderRadius: "50%",
                            padding: "5px",
                            zIndex: 2, // Place icon above the video
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            document.querySelector(`#audioLink`).click()
                          } // Trigger file input on icon click
                        />
                      </>
                    ) : (
                      <img src={require("../../../assets/images/upload.png")} />
                    )}
                  </span>
                  <input
                    type="file"
                    name="audioLink"
                    id="audioLink"
                    accept="audio/*"
                    style={{
                      position: "absolute",
                      top: "0",
                      left: "0",
                      width: "100%",
                      height: "100%",
                      opacity: 0, // Hide input when a video is present
                      zIndex: audioLink ? 0 : 2,
                      cursor: "pointer",
                    }}
                    onChange={handleImage}
                  />
                  {!audioLink && (
                    <p>
                      <label>Click to upload audio</label> or <br /> drag &amp;
                      drop
                    </p>
                  )}
                </div>
                {errors.audioLink && (
                  <p className="d-flex justify-content-start text-danger ">
                    {errors.audioLink}
                  </p>
                )}
              </div>
            )}
          </div>
          <button
            className="Button Discard"
            onClick={() => {
              setUpdateState(initialState);
            }}
          >
            Discard
          </button>
          <button className="Button" onClick={handleSubmit}>
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddEpisode;
